import React from 'react';
import { useSelector } from 'react-redux';
import { css } from '@/styled-system/css';
import type { RootReduxState } from 'app/shared/flux/reducers/index';
import { Module } from '../../../ui/Module/Module';
import { ExpiredListingBanner } from '../ExpiredListingBanner';
import { moduleConfig } from '../moduleConfig';

const moduleRendererContainer = css({
  display: 'flex',
  flexDirection: 'column',
  maxWidth: '100%',
});

export const ModuleRenderer = () => {
  const currentListing = useSelector((state: RootReduxState) => state.currentListingDetails?.currentListing);
  const clientLoaded = useSelector((state: RootReduxState) => state.app?.clientLoaded ?? false);
  const isListingActive = currentListing?.active !== false;

  return (
    <div className={moduleRendererContainer}>
      {!isListingActive && <ExpiredListingBanner />}
      {moduleConfig
        .filter((module) => module.enabled !== false)
        .filter((module) => !module.requiresClientLoaded || clientLoaded)
        .filter((module) => !module.shouldRender || module.shouldRender(currentListing))
        .map((module) => {
          const Component = module.component;

          return (
            <Module key={module.type} title={module.title} id={module.id}>
              <Component />
            </Module>
          );
        })}
    </div>
  );
};
